import { defineStore } from 'pinia'
import Cookie from '@/services/cookie'

export const useRepresentationStore = defineStore('representation', {
    state: () => ({
        token: '',
    }),

    getters: {
        get: (state) => state.token,
        isRepresentation: (state) => !!(state.token !== ''),
    },

    actions: {
        async checkToken() {
            const code = Cookie.getToken('_chat_auth_representation')
            if (code) {
               this.token = code
            } else {
                this.token = ''
            }
            return this.token
        },
    },
})